import { createContext } from 'react';

interface Context {
    sectionData: any;
    loadingState: any;
    setLoadingState: any;
    profile: any;
    setResponseMessage: any;
    setRemoveProfileState: any;
    fieldValues: any;
}

export const ProfileFormContext = createContext<Context>(undefined!);
